import { useStoreWithEqualityFn } from 'zustand/traditional';
import { Location, RouterState, useRouterStore } from './Router';

const locationSelector = (s: RouterState) => s.location;
const isEqual = (a: Location, b: Location) => a.pathname === b.pathname && a.search === b.search;
export const useLocation = () => {
  const store = useRouterStore();
  return useStoreWithEqualityFn(store, locationSelector, isEqual);
};
